module.exports = __webpack_public_path__ + "img/scene3.a61b7c4f.png";